import { autocomplete } from '@algolia/autocomplete-js';
import { Client  } from 'typesense';

$(document).ready(function () {
    let typesenseClient = new Client({
        'nearestNode': {'host': TYPESENSE_HOST, 'port': TYPESENSE_PORT, 'protocol': 'https'},
        'nodes': [
            {'host': TYPESENSE_HOST, 'port': TYPESENSE_PORT, 'protocol': 'https'},
        ],
        'apiKey': TYPESENSE_API_KEY_PUBLIC,
        'connectionTimeoutSeconds': 2
    })

    autocomplete({
        container: '#algolia-search',
        placeholder: 'Cine caută, găsește!',
        openOnFocus: true,
        async getSources({query}) {
            const results = await typesenseClient.collections(ESI_SEARCH_SUGGESTIONS).documents().search({
                q: query,
                filter_by: 'store_id: [' + CURRENT_STORE_ID + ']',
                preset: ESI_SEARCH_SUGGESTIONS,
                highlight_full_fields: 'query',
                include_fields: 'query'
            })

            return [
                {
                    sourceId: 'predictions',
                    getItems() {
                        return results.hits;
                    },
                    getItemInputValue({item}) {
                        return item.document.query;
                    },
                    templates: {
                        item({ item, html }) {
                            // html is from the `htm` package. Docs: https://github.com/developit/htm

                            // Get the highlighted HTML fragment from Typesense results
                            //const html_fragment = html`${item.highlights.find(h => h.field === 'query' || {}).value || item.document['query']}`

                            // Send the html_fragment to `html` tagged template
                            // Reference: https://github.com/developit/htm/issues/226#issuecomment-1205526098
                            //return html`<div dangerouslySetInnerHTML=${{ __html: html_fragment }}></div>`

                            return html`<a class="aa-ItemLink" href="./index.php?route=product/search&search=${item.document['query']}" dangerouslySetInnerHTML=${{ __html: item.document['query'] }}></a>`;
                        },
                    },
                },
            ];
        },
        onSubmit(event) {
            location = "./index.php?route=product/search&search=" + event.state.query;
        }
    });

});
